<template>
  <div>
    <div class="searchBlock" v-if="isDynamic">
      <el-divider content-position="left">二维表搜索配置</el-divider>
      <el-form-item label="可搜索">
        <el-switch v-model="data.isSearch"></el-switch>
      </el-form-item>
    </div>
    <el-form>
    <el-form-item label="默认值：" label-width="100px" label-position="left">
      <el-input v-model="data.value"
                placeholder="默认值"></el-input>
    </el-form-item>
    <el-form-item label="字典配置：" label-postion="left"><br>
      <el-tabs v-model="data.dicOption"
               stretch
               @tab-click="handleTabClick">
        <el-tab-pane label="静态数据"
                     name="1">
          <draggable tag="ul"
                     :list="dicdata"
                     :group="{ name: 'dic' }"
                     ghost-class="ghost"
                     handle=".drag-item">
            <li v-for="(item, index) in dicdata"
                :key="index">
              <i class="drag-item el-icon-s-operation"
                 style="font-size: 16px; margin: 0 5px; cursor: move;"></i>
              <el-input style="margin-right: 5px;"
                        size="mini"
                        v-model="item.label"
                        placeholder="label"></el-input>
              <el-input size="mini"
                        v-model="item.value"
                        placeholder="value"></el-input>
              <el-button @click="handleRemoveFields(index)"
                         circle
                         plain
                         type="danger"
                         size="mini"
                         icon="el-icon-minus"
                         style="padding: 4px;margin-left: 5px;"></el-button>
            </li>
          </draggable>
          <div style="margin-left: 22px;">
            <el-button type="text"
                       @click="handleAddFields">添加列
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="远端数据"
                     name="2">
          网址
          <el-input v-model="data.dicUrl"
                    placeholder="远端数据字典网址"
                    ></el-input>
          请求方法
          <el-select v-model="data.dicMethod"
                     placeholder="请求方法"
                     style="width: 100%;">
            <el-option label="POST"
                       value="post"></el-option>
            <el-option label="GET"
                       value="get"></el-option>
          </el-select>
          标签值
          <el-input v-model="data.props.label">

          </el-input>
          属性值
          <el-input v-model="data.props.value"></el-input>
        </el-tab-pane>
      </el-tabs>
    </el-form-item>
    <el-divider content-position="left">动态显隐</el-divider>
    <caseCade :caseData="dynamicDisplayData" @replaceData="replaceCaseCade" />
    <!-- 扩展 字段采集 开始 -->
    <el-form-item label="采集资源:" v-if="!isDynamic">
      <el-select clearable v-model="data.resourceId" placeholder="请选择采集资源：" >
          <el-option
          v-for="item in resource"
          :key="item.resourceId"
          :label="item.tableComment"
          :value="item.resourceId">
          </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="采集字段:">
      <el-select clearable v-model="data.fieldName" placeholder="请选择采集字段">
          <el-option
          v-for="item in field"
          :key="item.columnName"
          :label="item.columnComment"
          :value="item.columnName">
          </el-option>
      </el-select>
    </el-form-item>
      <el-form-item label="是否回填：" v-if="!isDynamic">
      <el-switch v-model="data.writable"></el-switch>
    </el-form-item>
    <el-form-item label="联动URL：" label-width="100px" label-position="left">
        <el-input v-model="data.casUrl"></el-input>
      </el-form-item>
    <!-- <el-form-item label="移动端排列方向：" >
      <el-select v-model="data.direction"  placeholder="请选择移动端排列方向">
        <el-option label="横向" value="horizontal"></el-option>
        <el-option label="竖向" value="vertical"></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item label="边框：">
      <el-switch v-model="data.border"></el-switch>
    </el-form-item>
    <el-form-item label="尺寸："
                  v-if="data.border">
      <el-radio-group v-model="data.size"
                      size="mini">
        <el-radio-button label="medium">正常</el-radio-button>
        <el-radio-button label="small">小</el-radio-button>
        <el-radio-button label="mini">超小</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否禁用：">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见：">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏：" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填：">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
      <!-- <el-form-item label="显隐prop：" label-width="100px" label-position="left">
        <el-input v-model="data.dynamicHideProp"></el-input>
      </el-form-item>
      <el-form-item label="显隐条件：" label-width="100px" label-position="left">
        <el-input v-model="data.dynamicHideCondition"></el-input>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import mixinIsDynamic from '../../mixins/isDynamic'
import Draggable from 'vuedraggable'
import CaseCade from '../CaseCade'

export default {
  mixins: [mixinIsDynamic],
  name: 'ConfigRadio',
  props: ['data', 'widgetForm'],
  components: { Draggable, CaseCade },
  data() {
    return {
      resource: [],
      field: [],
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      },
      dicOption: '1',
      dicCopy: this.deepClone(this.data.dicData),
      dataProps: {},
      dicdata: this.data.dicData || [],
      dynamicDisplayData: this.data.dynamicDisplayData || []
    }
  },
  computed: {
  },
  mounted() {

  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    },
    handleRemoveFields(index) {
      // this.data.dicData.splice(index, 1)
      this.dicdata.splice(index, 1)
    },
    handleAddFields() {
      const i = Math.ceil(Math.random() * 99999)
      this.dicdata.push({ label: `字段${i}`, value: `col_${i}` })
      // this.data.dicData.push({ label: `字段${i}`, value: `col_${i}` })
    },
    handleTabClick(tab) {
      const { name } = tab
      if (name === '1') {
        this.data.dicUrl = ''
        delete this.data.remote
        delete this.data.dicMethod
        this.data.props = {}
        this.dicdata = []
        this.data.dicData = []

        /* if (this.dicCopy.length == 0){*/
        /* setTimeout(() => {
          console.log('i am a dicdata')
          this.data.dicData = this.dicCopy
        })
*/
        /* }*/
      } else {
        /* delete this.data.dicData
        if (this.dataProps.url && this.dataProps.label && this.dataProps.value ){
          this.$message.info('i am a dataprops')
        }*/
        this.data.remote = true
        delete this.data.dicData
        this.data.dicUrl = ''
      }
    },
    replaceCaseCade(data) {
      this.data.dynamicDisplayData = data
    }
  },
  watch: {
    'data.resourceId': function(val) {
      if (val) {
        this.resourceIdChange(val)
      }
    },
    'data.required': function(val) {
      if (val) this.validator.required = { required: true, message: `请选择${this.data.label}` }
      else this.validator.required = null

      this.generateRule()
    },
    'data.dicData': {
      handler(val) {
        if (val && val.length > 0 && !Object.is(val, this.dicdata)) {
          this.dicdata = val
        }
      },
      deep: true
    },
    dicdata: {
      handler(val) {
        this.data.dicData = val
      },
      deep: true
    }
    /* 'data.props': {
      handler(val){
        if(val) {
          if(val.dicUrl){
            this.dataProps.url = val.dicUrl
          }
          if(val.label){
            this.dataProps.label = val.label
          }
          if(val.value){
            this.dataProps.value = val.value
          }
        }
      },
      deep: true
    },
    dataProps:{
      handler(val){
        if (val.label && val.value && val.url){
          this.data.dicUrl = val.url
          this.data.props = this.dataProps
          this.data.remote = true

        }
      },
      deep: true
    }*/
  }
}
</script>

<style scoped>
@import './search.scss';
</style>
